<template>
    <div :class="themeClass" @mouseleave="hover(false)" @mouseover="hover(true)" class="vc-cart-item">
        <div :class="cartItem.type === 'collection' ? 'tw-pointer-events-none' : ''">
            <item-avatar :active="hovered" :item="cartItem.item" class="vc-cart-item__avatar"></item-avatar>
        </div>
        <span class="vc-cart-item__header">
            <item-link :itemId="itemId"
                       :itemType="cartItem.type === 'collection' ? 'beattapes': cartItem.type"
                       class="vc-cart-item__name">
                {{cartItem.item.name}}
            </item-link>
            <span class="vc-cart-item__license" :class="{
                'hover:tw-underline': ! ['service', 'service_quote'].includes(cartItem.type)
            }">
                <button @click="showLicenseModal(cartItem.license)" class="c-button" v-if="cartItem.type === 'beat'">
                    {{cartItem.license.name}}
                </button>
                <button @click="showSoundkitTermsModal(cartItem.license)" class="c-button" v-if="cartItem.type === 'soundkit'">
                    {{cartItem.license.pricingTemplateOption.name}}
                </button>
                <button  class="tw-pointer-events-none c-button" v-if="cartItem.type === 'collection' || cartItem.type === 'beattapes'">
                    {{cartItem.item.itemsCount ? cartItem.item.itemsCount + " Beats": null }}
                </button>
                <div class="tw-flex tw-space-x-3" v-if="['service', 'service_quote'].includes(cartItem.type)">
                     <div
                         v-for="detail in [{
                        icon: ['far', 'clock'],
                        label: cartItem.item.deliveryLabel
                    },
                    {
                        icon: 'repeat',
                        label: cartItem.item.revisions + ' Revisions'
                        }
                    ]">
                    <font-awesome-icon :icon="detail.icon" class="tw-mr-0.5" />
                    {{ detail.label }}
                </div>
                </div>
            </span>
        </span>
        <span class="vc-cart-item__price">
            <s v-if="originalItemPrice!==null" class="vc-cart-item__price--strike">{{originalItemPrice | displayPrice}}</s> <span :class="originalItemPrice!==null?'vc-cart-item__price--bold':null">{{cartItem.price | displayPrice(true)}}</span>
        </span>
        <button @click="$emit('removeCartItem', cartItem)" class="vc-cart-item__remove c-button">
            <font-awesome-icon :icon="['fal', 'times']"></font-awesome-icon>
        </button>
    </div>
</template>

<script>
import Configure from '../../mixins/configure'

import ItemAvatar from '../item/item-avatar.vue'
import ItemLink from '../item/item-link.vue'

export default {
        name: "cart-item",
        props: {
            cartItem: {
                type: Object,
                required: true,
            },
            theme: {
                type: String,
                default: 'cartPopup',
                validator: function (value) {
                    return ['cartPopup', 'checkout'].indexOf(value) !== -1;
                }
            }
        },
        components: {
            ItemLink,
            ItemAvatar
        },
        mixins: [Configure],
        computed: {
            itemId() {
                switch (this.cartItem.type) {
                    case 'beat':
                        return this.cartItem.item.alias;
                    case 'service_quote':
                        return this.cartItem.item.service_id;
                    default:
                        return this.cartItem.item.id;
                }
            },
            isBeatTape(){
                return this.cartItem.type === 'collection'
            },
            hovered() {
                if (this.isBeatTape) return false;
                return this.$data.$hover.musicContainer;
            },
            licenses() {
                return this.$store.getters.licenses;
            },
            themeClass() {
                return {
                    'vc-cart-item--cart-popup-theme': this.theme === 'cartPopup',
                    'vc-cart-item--checkout-theme': this.theme === 'checkout',
                }
            },
            originalItemPrice(){
                let originalPrice = null
                if (this.cartItem.item.getType() ==="beat") {
                    originalPrice =  parseFloat(this.cartItem.item.pricing[this.cartItem.license.id].price);
                } else if (this.cartItem.item.getType() === "soundkit") {
                    originalPrice = this.cartItem.license.price
                }
                else originalPrice = parseFloat(this.cartItem.item.price);

                if(originalPrice === parseFloat(this.cartItem.price)) return null

                return originalPrice
            }
        },
        methods: {
            hover(isHovering) {
                this.$data.$hover.musicContainer = isHovering;
            },
            showLicenseModal(license) {
                this.$store.commit('modalLicense', {modalLicense: license});
                $('#license-terms').modal('show');
            },
            showSoundkitTermsModal(license) {
              this.$modal.show("soundkit-terms", { pricingOption: license })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .vc-cart-item {
        $cart-item: &;
        display: grid;
        align-items: center;
        grid-template-columns: 52px auto auto 22px;
        grid-column-gap: 10px;

        &__header {
            display: flex;
            flex-direction: column;

            &, & > * {
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }
        }

        &__name {
            font-size: 14px;
            font-weight: 600;

            &:hover {
                text-decoration: underline;
            }
        }

        &__license > * {
            font-size: 11px;
            font-weight: 400;

            &:hover {
                text-decoration: underline;
            }
        }

        &__price {
            justify-self: end;
        }

        &__remove {
            font-size: 13px;
            justify-self: center;
            width: 22px;
            height: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 100%;
        }

        &--cart-popup-theme {
            #{$cart-item} {
                &__name {
                    color: var(--menu-item-text-color);
                }

                &__license > *, &__price {
                    color: var(--menu-item-active-text-color);

                }
                &__remove {
                    color: var(--menu-item-text-color);

                    &:hover {
                        background: var(--menu-item-active-text-color-faded);

                    }
                }
            }
        }

        &--checkout-theme {
            #{$cart-item} {
                &__name {
                    color: var(--primary-text-color);
                }

                &__license > *, &__price {
                    color: var(--highlight-color);

                }
                &__price {
                    &--strike{
                        color: var(--secondary-text-color);
                    }
                    &--bold{
                        font-weight: bold;
                    }
                }
                &__remove {
                    color: var(--primary-text-color);

                    &:hover {
                        background: var(--highlight-color-faded);

                    }
                }
            }
        }
    }
</style>
